import React from "react";
import DrawingCanvas from "./DrawingCanvas";
import { type Line } from "./models";

interface Props {
  lines: Line[]
  error: boolean
  onLinesChanged: (newLines: Line[]) => void
  svgRef: React.RefObject<SVGSVGElement>
  width?: number
}

export default class SigningCanvas extends React.Component<Props> {
  public render(): JSX.Element {
    return <DrawingCanvas
      svgRef={this.props.svgRef}
      style={{
        backgroundColor: "white",
        border: this.props.error ? "1px solid var(--input-error-border)" : "1px solid var(--border-active)",
        borderRadius: "var(--radius-large)",
        cursor: "crosshair",
        height: 100,
        width: this.props.width
      }}
      lines={this.props.lines}
      onLinesChanged={this.props.onLinesChanged}
    >
      <hr style={{
        position: "relative",
        top: "73%",
        backgroundColor: "var(--esign-sign-line-color)",
        height: 1,
        margin: "0 20px 0 20px"
      }} />
    </DrawingCanvas>;
  }
}
